export const transition = 'transition: width 400ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;';
export const openedWidth = (isOpened, width) => isOpened ? width : 0;
export const openedOverflow = (isOpened) => isOpened ? 'auto' : 'hidden';
